import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'singleFieldData/'

const initialState = {
    singleFieldData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const addNewSingleFieldData = createAsyncThunk('sfd/ansfd', async (sfData, thunkAPI) => {
    try {

        await axios.post(API_URL + 'addNewSingleFieldData', sfData)

        return sfData

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const getAllSingleFieldData = createAsyncThunk('sfd/galsfd', async (sfData, thunkAPI) => {
    try {

        const result = await axios.post(API_URL + 'getAllSingleFieldData', sfData)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const singleFieldSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
            state.singleFieldData = []
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(addNewSingleFieldData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addNewSingleFieldData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.singleFieldData.push(action.payload)
            })
            .addCase(addNewSingleFieldData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getAllSingleFieldData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllSingleFieldData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.singleFieldData = action.payload
            })
            .addCase(getAllSingleFieldData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = singleFieldSlice.actions

export default singleFieldSlice.reducer